/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import * as strings from '@touchplan/strings';
import { Router } from '@angular/router';
import { LoadingBlockerState } from '../loading-blocker/loading-blocker';
import { Subject } from 'rxjs';
import { ProjectFirebaseCloudFunctionsService } from 'src/app/services/firebase-cloud-functions/project-cloud-functions.service';

@Component({
	selector: 'access-code-quick-join',
	templateUrl: './access-code-quick-join.component.html',
	styleUrls: ['./access-code-quick-join.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessCodeQuickJoinComponent implements OnInit {
	@Input() public userId: string;

	public loadingObservable: Subject<LoadingBlockerState> = new Subject();
	public appStrings = strings;
	private validCharactersRegex = /[^a-z0-9]/gi;

	public accessCodeForm = this.formBuilder.group({
		accessCode: ['', Validators.required],
	});

	constructor(
		private formBuilder: UntypedFormBuilder,
		private router: Router,
		private projectFBCloudFunctionsService: ProjectFirebaseCloudFunctionsService
	) {}

	public ngOnInit() {}

	public tryCode(): void {
		if (!this.accessCodeForm.valid) {
			Logging.warning(strings.ACCESS_CODE_QUICK_JOIN_NEED_CODE);
			return;
		}
		// This filters invalid characters from the user input string. Not having this will cause an error in Firebase.
		const code = this.accessCodeForm.value.accessCode.replace(this.validCharactersRegex, '');
		// Start loading
		this.loadingObservable.next(LoadingBlockerState.inProgress);

		this.projectFBCloudFunctionsService.addUserToProjectViaRallyPoint(this.userId, code).subscribe({
			next: (result) => {
				this.loadingObservable.next(LoadingBlockerState.complete);
				this.router.navigate(['plan', result.projectId, result.planId]);
			},
			error: (e) => {
				this.loadingObservable.next(LoadingBlockerState.failure);
				Logging.warning(e.message);
			},
		});
	}
}
